import React, { useState } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';

const CustomBannerCheckBox = ({ orderNumber ,isPaid}) => {
  const [isChecked, setIsChecked] = useState(isPaid);
    const { t } = useTranslation();
  // console.log(isPaid)
  return (
    <div
      className={`flex w-full items-center justify-between p-2 lg:py-4 lg:px-4 rounded-sm shadow-md bg-custom-yellow text-black`}
    >
        {/* Order Number */}
        <div className="font-bold">
        <span className="text-xs text-gray-800 lg:text-sm">{t("orderNumber")} : </span>
        <span className="text-xs text-gray-800 lg:text-sm" dir="ltr"> {orderNumber}</span>
      </div>
      <div className="flex items-center gap-2">
        <span
          className={`relative lg:w-5 lg:h-5 w-4 h-4 rounded-sm lg:rounded-md flex items-center justify-center border-2 text-black ${
            isChecked ? "bg-green-600 border-green-600" : "bg-white border-gray-300"
          }`}
        >
          {isChecked && <CheckIcon className="w-4 h-4 text-white" />}
          <input
            type="checkbox"
            className="absolute inset-0 opacity-0 "
            checked={isChecked}
          />
        </span>
        <span
          className={`text-xs lg:text-sm font-medium  ${
            isChecked ? "text-black" : "text-black"
          }`}
        >
          {isChecked ? t("PaymentSuccessfully") : ""}
        </span>
      </div>

    
  </div>
  );
};

export default CustomBannerCheckBox;
